import { ObservableQuery } from '@apollo/client';
import { ProjectMember, ProjectRole } from '@ih/app/shared/apis/interfaces';

export class FindAllProjectRolesSuccess {
  public static readonly type =
    '[Project/ProjectRoles/List] FindAllProjectRolesSuccess';
  constructor(
    public readonly result: ObservableQuery.Result<{
      findAllProjectRoles: ProjectRole[];
    }>,
    public readonly members: ProjectMember[],
    public readonly defaultRoles: ProjectRole[],
  ) {}
}
